<template>
    <div>
        <div>
<!--
            <b-card no-body>
                <b-tabs card>
                    <b-tab title="Tab 1" active>
-->
<!--
                        <b-form-input v-model="value"></b-form-input>
-->
                        <b-input-group class="mb-1">
                            <b-form-input v-model="query" placeholder="カテゴリー名、カテゴリーID" @keydown.enter.native="search"></b-form-input>
                            <b-input-group-append>
                            </b-input-group-append>
                            <template #append>
                                <b-button
                                    variant="secondary"
                                    @click="search"
                                    >
                                    検索
                                </b-button>
                            </template>
                        </b-input-group>
                        <template v-if="query_result.data && query_result.data.hits && query_result.data.hits.length">
                            <div v-for="(hit, index) in query_result.data.hits" class="text-left">
                                <ItemCategoryQueryResult v-model="query_result.data.hits[index]" @click="onClickItemCategoryResult" />
                            </div>
                        </template>

                        <div v-for="(options_by_level, index) in options" class="mt-2">
                            <vue-select
                                v-model="values[index]"
                                :options="options_by_level"
                                :get-option-label="(option) => { return option.text + ' #' + option.category_id + '#' }"
                                :size="size"
                                :reduce="v => v.category_id"
                                :filter="filterOption"
                                @input="input"
                                :placeholder="'level.' + (index + 1) + 'カテゴリーを選ぶ'"
                        
                                append-to-body
                                :calculate-position="withPopper"
                                >
                            </vue-select>
                        </div>
<!--
                    </b-tab>
                    <b-tab title="Tab 2">
                    </b-tab>
                </b-tabs>
            </b-card>
-->
            <div class="text-left">
                <span
                    class="text-danger"
                    v-if="valueObject && !valueObject.is_leaf"
                    >
                    より詳細なleafカテゴリーを選択してください。
                </span>
            </div>
        </div>
    </div>
</template>

<script>
import Fuse from 'fuse.js'
import { createPopper } from '@popperjs/core'
import ItemCategoryQueryResult from '@/components/ItemCategoryQueryResult'

export default {
    components: {
        ItemCategoryQueryResult,
    },
    props: {
        value: {
            type: [ String, Number ],
            required: false,
            default: '',
        },
        size: {
            type: String,
            required: false,
            default: 'sm',
        },
        provider: {
            type: String,
            required: false,
            default: 'ebay',
        },
    },
    data() {
        return {
            values: [],
            options: [],

            query: '',
            query_result: {},
        }
    },
    computed: {
//        async options() {
//            let options = {}
//            switch (this.provider) {
//                case 'ebay':
//                    options = {
//                        0: [],
//                        1: [],
//                        2: [],
//                    }
//                    break
//                case 'amazon':
//                    break
//            }
//        },
        valueObject() {
            for (let i = this.options.length - 1; i >= 0; i--) {
                for (let j = 0; j < this.options[i].length; j++) {
                    if (this.value === this.options[i][j].category_id) {
                        return this.options[i][j]
                    }
                }
            }
            return null
        },
    },
    async mounted() {
        this.fetch(this.value)
    },
    methods: {
        searchReset() {
            this.query = ''
            this.$utils.empty(this.query_result)
        },
        async search(event, query = null) {
            if (query) {
                this.query = query
            }

            let result = await this.$store
                .dispatch('item_category/search', {
                    provider: this.provider,
                    query: this.query,
                })
                .then((response) => {
                    return response.data
                })
                .catch((error) => {
                    return []
                })

            if (result.data && result.data.hits && result.data.hits.length === 1) {
                this.onClickItemCategoryResult(result.data.hits[0])
                return
            }

            this.$utils.empty(this.query_result)
            this.$utils.set(this.query_result, result)
        },
        async fetch(category_id) {
            let options = await this.$store
                .dispatch('item_category/options', {
                    provider: this.provider,
                    category_id: category_id,
                })
                .then((response) => {
                    return response.data
                })
                .catch((error) => {
                    return []
                })

            this.$utils.empty(this.options)
            this.$utils.set(this.options, options)

            this.$utils.empty(this.values)
            for (let i = options.length - 1; i >= 0; i--) {
                if (i === 0) { break }
                let value_new = options[i][0].parent_id
                if (!this.values.includes(value_new)) {
                    this.values.unshift(value_new)
                }
            }
            if (this.values.length < options.length) {
                let hits = options[options.length - 1].filter((v) => { return v.category_id === category_id })
                if (hits.length) {
                    this.values.push(category_id)
                }
            }
        },
        onClickItemCategoryResult(category) {
            this.input(category.category_id)
            this.searchReset()
        },
        input(value) {
            if (!value) {
                for (let i = 0; i < this.values.length; i++) {
                    if (!this.values[i]) {
                        break
                    }
                    value = this.values[i]
                }
            }
            this.fetch(value)
            this.$emit('input', value)
        },





        filterOption(options, search) {
            const fuse = new Fuse(options, {
                keys: [ 'category_id', 'text', ],
                shouldSort: true,

                tokenize: true,
//                ignoreLocation: true,

                includeMatches: true,
                minMatchCharLength: 1,
                threshold: 0.9,
            })
setTimeout(() => {
    const dropdownList = document.querySelector('ul.vs__dropdown-menu')
    if (dropdownList) {
        console.log(dropdownList.scrollTop = 0)
    }
} , 1)
            return search.length
                ? fuse.search(search).map(({ item }) => item)
                : fuse.list
        },
        withPopper(dropdownList, component, { width }) {
            /**
             * We need to explicitly define the dropdown width since
             * it is usually inherited from the parent with CSS.
             */
            dropdownList.style.width = width
            dropdownList.style.height = '350px'

            /**
             * Here we position the dropdownList relative to the $refs.toggle Element.
             *
             * The 'offset' modifier aligns the dropdown so that the $refs.toggle and
             * the dropdownList overlap by 1 pixel.
             *
             * The 'toggleClass' modifier adds a 'drop-up' class to the Vue Select
             * wrapper so that we can set some styles for when the dropdown is placed
             * above.
             */
            const vm = this
            const popper = createPopper(component.$refs.toggle, dropdownList, {
                placement: 'bottom',
                modifiers: [
                    {
                        name: 'offset',
                        options: {
                            offset: [0, -1],
                        },
                    },
                    {
                        name: 'toggleClass',
                        enabled: true,
                        phase: 'write',
                        fn({ state }) {
                            component.$el.classList.toggle(
                                'drop-up',
                                state.placement === 'top'
                            )
                        },
                    },
                ],
            })
            
            /**
             * To prevent memory leaks Popper needs to be destroyed.
             * If you return function, it will be called just before dropdown is removed from DOM.
             */
            return () => popper.destroy()
        },
    },
}
</script>

<style>
.v-select.drop-up.vs--open .vs__dropdown-toggle {
    border-radius: 0 0 4px 4px;
    border-top-color: transparent;
    border-bottom-color: rgba(60, 60, 60, 0.26);
}

[data-popper-placement='top'] {
    border-radius: 4px 4px 0 0;
    border-top-style: solid;
    border-bottom-style: none;
    box-shadow: 0 -3px 6px rgba(0, 0, 0, 0.15);
}
</style>

<style>
.vs__dropdown-menu {
    z-index: 2000;
}
</style>

